import React, { useEffect, useState } from "react";
import logo from "../pictures/TheBestescafflogo.png";
import Sidebar from "../components/Sidebar";
import FourButtons from "../components/FourButtons";
import { Switch, CircularProgress, useMediaQuery } from "@mui/material";
import outro from "../pictures/outro.png";
import { useDispatch, useSelector } from "react-redux";
import {
  addTemproryRoofQoute,
  adminActions,
  fetchPriceList,
  fetchSingleJob,
  fetchTemproryRoofQoutation,
  signOut,
} from "../store/adminSlice";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import escapeHtml from "../functions/Validator";
import Swal from "sweetalert2";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloseIcon from "@mui/icons-material/Close";
import HeaderScaff from "../components/HeaderScaff";
import IconButton from "@mui/material/IconButton";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import CircleIcon from "@mui/icons-material/Circle";

function TemporaryRoofQuotes() {
  const isNonMobile = useMediaQuery("(min-width: 768px)");
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [needed, setNeeded] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const _id = useSelector((state) => state.admin._id);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const queryParameters = new URLSearchParams(window.location.search);
  const id = queryParameters.get("id");
  const stateSingleJob = useSelector((state) => state.admin.singleJob);
  const statePriceList = useSelector((state) => state.admin.priceList);
  const StateTemporaryRoofQoutation = useSelector(
    (state) => state.admin.temporaryRoofQoutation
  );
  const escaffQuotationSwalAlert = useSelector((state) => state.admin.swalAlert);
  const [data, setData] = useState(StateTemporaryRoofQoutation);
  const [result, setResult] = useState(0);
  const statesignOut = useSelector((state) => state.admin.signOut);
  const subscribed = useSelector((state) => state.admin.subscribed);

  useEffect(() => {
    if (!_id) {
      navigate("/signin");
    } else if (!subscribed) {
      navigate("/signin");
    }
    if (!isNonMobile) {
      setSidebarOpen(false);
    }
  }, []);

  useEffect(() => {
    if (statesignOut === "signOut") {
      dispatch(signOut());
    }
  }, [statesignOut]);

  useEffect(() => {
    setIsLoading(true);
    if (id) {
      Promise.all([
        dispatch(fetchSingleJob({ _id: id, adminID: _id })),
        dispatch(fetchPriceList({ adminID: _id })),
      ])
        .then(() => {
          setIsLoading(false);
        })
        .catch((err) => {
          setError("Failed to load job data. Please try again.");
          setIsLoading(false);
        });
    } else {
      navigate("/pendingprojectqoutes");
    }
  }, []);

  useEffect(() => {
    if (escaffQuotationSwalAlert.message === "Saved") {
      Swal.fire({
        icon: "success",
        title: "Saved",
        confirmButtonColor: "#60c088",
      }).then(() => {
        dispatch(adminActions.removeSwalAlert());
        window.location.reload();
      });
    }
    if (escaffQuotationSwalAlert.message === "updatedEscaff") {
      Swal.fire({
        icon: "success",
        title: "Updated",
        confirmButtonColor: "#60c088",
      }).then(() => {
        dispatch(adminActions.removeSwalAlert());
        window.location.reload();
      });
    }
  }, [escaffQuotationSwalAlert]);

  useEffect(() => {
    dispatch(fetchTemproryRoofQoutation({ jobID: id, adminID: _id }));
    dispatch(adminActions.removeSwalAlert());
  }, []);

  useEffect(() => {
    if (!window.location.hash) {
      window.location = window.location + "#loaded";
      window.location.reload();
    }
  }, []);

  useEffect(() => {
    setData(StateTemporaryRoofQoutation);
  }, [StateTemporaryRoofQoutation]);

  const handleCalculate = () => {
    var WeeklyScaffoldingInspection =
      statePriceList.scaffoldingInspectionPerVisit;
    var lowerScaffoldSection =
      parseInt(data.permiterOfBuilding) *
      parseInt(data.numberOfLiftsForPerimeter) *
      parseInt(statePriceList.linearMerterageCost);

    var upperScaffoldingSectionOne =
      parseInt(data.lengthOfBuilding) *
      parseInt(data.HeightFromGutteringToTop) *
      2;

    var upperScaffoldingSectionTwo =
      parseInt(data.widthOfBuilding) *
      parseInt(data.HeightFromGutteringToTop) *
      2;

    var covering =
      (upperScaffoldingSectionOne + upperScaffoldingSectionTwo) *
      parseInt(data.monoflexOrShrinkWrap);

    var tempRoof =
      parseInt(data.widthOfBuilding) *
      parseInt(data.lengthOfBuilding) *
      parseInt(data.HeightFromGutteringToTop) *
      parseInt(statePriceList.temporaryRoof);

    var totalCostResult = lowerScaffoldSection + covering + tempRoof;

    var weeks = data.numberOfWeeks;
    if (data.weeklyScoffoldingInspectionSwitch) {
      var nweek = weeks - 1;
      var r1 = nweek * WeeklyScaffoldingInspection;
      console.log(r1);
      totalCostResult = totalCostResult + r1;
      console.log(totalCostResult);
    }
    if (data.customerVatRegisterSwitch) {
      var theVatPercentage = (data.customerVatRegister / 100) * totalCostResult;

      totalCostResult = totalCostResult + theVatPercentage;
    }
    var nonpercentage =
      parseInt(data.streetLicenseCost) + parseInt(data.externalDesingCost);
    if (data.numberOfWeeks > data.standardNumberOfWeek) {
      var percentageWeek = weeks - data.standardNumberOfWeek;

      var overhired = statePriceList.overhirePercentage * percentageWeek;
      console.log(overhired, "overhired");

      var orignalPercentage = (overhired / 100) * totalCostResult;

      console.log(orignalPercentage, "percentafeoverfi");
      totalCostResult = totalCostResult + nonpercentage + orignalPercentage;
    } else {
      console.log(orignalPercentage, "percentafeoverfi");
      totalCostResult = totalCostResult + nonpercentage;
    }

    console.log(data.numberOfWeeks, "ddd", data.standardNumberOfWeek);

    setResult(totalCostResult.toFixed(2));
    setData({
      ...data,
      jobID: id,
      customerID: stateSingleJob.customer._id,
      totalCostResult: totalCostResult,
      approved: 0,
    });
  };

  const handleSubmit = () => {
    if (!result) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        confirmButtonColor: "#60c088",
        text: "Kindly calculate first.!",
      });
    } else {
      dispatch(addTemproryRoofQoute(data));
    }
  };

  return (
    <div className="w-full h-full">
      <HeaderScaff setSidebarOpen={setSidebarOpen} />
      <div className={`${sidebarOpen ? "" : isNonMobile ? "" : "flex-col"} 'w-full flex h-auto p-2 sm:p-6'`}>
        <div className={`${sidebarOpen ? isNonMobile ? "basis-1/5" : "flex justify-center w-full" : "hidden"} "w-full h-full"`}>
          <Sidebar
            setSidebarOpen={setSidebarOpen}
            needed={needed}
            isNonMobile={isNonMobile}
          />
        </div>

        <div
          onClick={() => setSidebarOpen(true)}
          className={`${
            sidebarOpen
              ? isNonMobile
                ? "hidden"
                : "hidden"
              : isNonMobile
              ? "flex w-12 mt-4"
              : "flex border-2 border-x-0 bg-gray-100/50 mt-2 -mb-1 w-full items-center justify-center"
          } h-fit`}
        >
          <div className={`${sidebarOpen ? isNonMobile ? "" : "" : isNonMobile ? "" : "hidden"}`}>
            <IconButton onClick={() => setSidebarOpen(true)}>
              <ArrowForwardIosIcon />
            </IconButton>
          </div>
          <div className={`${sidebarOpen ? isNonMobile ? "hidden" : "hidden" : isNonMobile ? "hidden" : "flex"}`}>
            <p className="text-gray-500 text-xs py-[2px]">Sidebar</p>
          </div>
        </div>

        <div className={`${sidebarOpen ? isNonMobile ? "lg:basis-3/4 w-full" : "hidden" : isNonMobile ? "w-full" : "hidden"} " "`}>
          {/* Header Title Section */}
          <div className="w-full flex justify-between mt-4">
            <div className="flex space-x-2">
              <p className="text-base md:text-xl xxl:text-2xl text-slate-600 font-medium pb-1 ml-2 hover:text-black cursor-pointer whitespace-nowrap">
                Temporary Roof Quote
                <CircleIcon
                  sx={{ width: "17px", height: "17px" }}
                  className="text-green-600 ml-1"
                />
              </p>
            </div>
          </div>

          {/* Main Content */}
          {isLoading ? (
            <div className="w-full h-screen flex flex-col items-center justify-center bg-gray-50">
              <img src={logo} alt="Escaff Logo" className="h-16 mb-6" />
              <CircularProgress color="success" />
              <p className="mt-4 text-gray-600">Loading quotation data...</p>
            </div>
          ) : error ? (
            <div className="w-full h-screen flex flex-col items-center justify-center bg-gray-50">
              <img src={logo} alt="Escaff Logo" className="h-16 mb-6" />
              <div className="text-red-600 font-medium mb-4">{error}</div>
              <button
                onClick={() => window.location.reload()}
                className="px-4 py-2 bg-lightgreen hover:bg-darkgreen text-white font-medium rounded-md shadow-sm"
              >
                Try Again
              </button>
            </div>
          ) : (
            <div className="w-full px-2 mt-2">
              <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
                <div className="flex flex-col lg:flex-row gap-6">
                  {/* Left Column - Form */}
                  <div className="w-full lg:w-1/2">
                    <div className="space-y-6">
                      <div className="space-y-2">
                        <label className="block text-sm font-medium text-gray-700">
                          Select the date of erection
                        </label>
                        <input
                          className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                          value={data.dateOfErection}
                          type="date"
                          onChange={(e) =>
                            setData({
                              ...data,
                              dateOfErection: new Date(e.target.value).toISOString().split('T')[0],
                              nextInspectionDate: new Date(e.target.value).toISOString().split('T')[0],
                            })
                          }
                          required
                        />
                      </div>

                      <div className="space-y-2">
                        <label className="block text-sm font-medium text-gray-700">
                          Enter the number of weeks required
                        </label>
                        <input
                          className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                          value={data.numberOfWeeks}
                          onChange={(e) =>
                            setData({
                              ...data,
                              numberOfWeeks: escapeHtml(e.target.value),
                            })
                          }
                          type="number"
                          onWheel={(e) => e.target.blur()}
                          required
                        />
                      </div>

                      <div className="space-y-2">
                        <label className="block text-sm font-medium text-gray-700">
                          Enter the number of standard weeks hire before overhire
                          commence
                        </label>
                        <input
                          className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                          onChange={(e) =>
                            setData({
                              ...data,
                              standardNumberOfWeek: escapeHtml(e.target.value),
                            })
                          }
                          value={data.standardNumberOfWeek}
                          type="number"
                          required
                          onWheel={(e) => e.target.blur()}
                        />
                      </div>

                      <div className="mt-8">
                        <h3 className="text-md font-medium text-gray-800 mb-4">
                          Temporary roof dimensions
                        </h3>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                          <div className="space-y-2">
                            <label className="block text-sm font-medium text-gray-700">
                              Enter the perimeter of your building{" "}
                              <span className="text-gray-400">(Red line)</span>
                            </label>
                            <input
                              className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                              value={data.permiterOfBuilding}
                              onChange={(e) =>
                                setData({
                                  ...data,
                                  permiterOfBuilding: escapeHtml(e.target.value),
                                })
                              }
                              type="number"
                              onWheel={(e) => e.target.blur()}
                              required
                            />
                          </div>

                          <div className="space-y-2">
                            <label className="block text-sm font-medium text-gray-700">
                              Number of lifts{" "}
                              <span className="text-gray-400">(Blue line)</span>
                            </label>
                            <input
                              className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                              value={data.numberOfLiftsForPerimeter}
                              onChange={(e) =>
                                setData({
                                  ...data,
                                  numberOfLiftsForPerimeter: escapeHtml(
                                    e.target.value
                                  ),
                                })
                              }
                              type="number"
                              onWheel={(e) => e.target.blur()}
                              required
                            />
                          </div>
                        </div>

                        <div className="space-y-2">
                          <label className="block text-sm font-medium text-gray-700">
                            Enter the width of the building
                          </label>
                          <input
                            className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                            value={data.widthOfBuilding}
                            onChange={(e) =>
                              setData({
                                ...data,
                                widthOfBuilding: escapeHtml(e.target.value),
                              })
                            }
                            type="number"
                            onWheel={(e) => e.target.blur()}
                            required
                          />
                        </div>

                        <div className="space-y-2">
                          <label className="block text-sm font-medium text-gray-700">
                            Enter the length of the building
                          </label>
                          <input
                            className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                            type="number"
                            onWheel={(e) => e.target.blur()}
                            value={data.lengthOfBuilding}
                            onChange={(e) =>
                              setData({
                                ...data,
                                lengthOfBuilding: escapeHtml(e.target.value),
                              })
                            }
                            required
                          />
                        </div>

                        <div className="space-y-2">
                          <label className="block text-sm font-medium text-gray-700">
                            Enter the height from your guttering to the top of roof{" "}
                            <span className="text-gray-400">(Green line)</span>
                          </label>
                          <input
                            className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                            type="number"
                            onWheel={(e) => e.target.blur()}
                            value={data.HeightFromGutteringToTop}
                            onChange={(e) =>
                              setData({
                                ...data,
                                HeightFromGutteringToTop: escapeHtml(e.target.value),
                              })
                            }
                            required
                          />
                        </div>
                      </div>

                      <div className="space-y-2">
                        <label className="block text-sm font-medium text-gray-700">
                          Shrinkwrap or Monoflex
                        </label>
                        <select
                          className="bg-gray-100 border border-gray-200 rounded p-2 w-full md:w-2/3 focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                          onChange={(e) =>
                            setData({
                              ...data,
                              monoflexOrShrinkWrap: escapeHtml(e.target.value),
                            })
                          }
                        >
                          <option>Select</option>
                          <option
                            selected={
                              statePriceList.monoflex === data.monoflexOrShrinkWrap
                            }
                            value={statePriceList.monoflex}
                          >
                            Monoflex
                          </option>
                          <option
                            selected={
                              statePriceList.shrinkwrap === data.monoflexOrShrinkWrap
                            }
                            value={statePriceList.shrinkwrap}
                          >
                            Shrinkwrap
                          </option>
                        </select>
                      </div>

                      <div className="flex items-center space-x-4">
                        <label className="text-sm font-medium text-gray-700">
                          Weekly Scaffolding Inspections
                        </label>
                        <Switch
                          onChange={() =>
                            setData({
                              ...data,
                              weeklyScoffoldingInspectionSwitch:
                                !data.weeklyScoffoldingInspectionSwitch,
                            })
                          }
                          checked={data.weeklyScoffoldingInspectionSwitch}
                          color="success"
                        />
                      </div>

                      <div className="space-y-2">
                        <label className="block text-sm font-medium text-gray-700">
                          Enter the Street license Cost
                        </label>
                        <input
                          className="bg-gray-100 border border-gray-200 rounded p-2 w-full md:w-1/2 focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                          type="number"
                          onChange={(e) =>
                            setData({
                              ...data,
                              streetLicenseCost: escapeHtml(e.target.value),
                            })
                          }
                          value={data.streetLicenseCost}
                          onWheel={(e) => e.target.blur()}
                          required
                        />
                      </div>

                      <div className="space-y-2">
                        <label className="block text-sm font-medium text-gray-700">
                          Customer is VAT Registered
                        </label>
                        <div className="flex items-center">
                          <input
                            className="bg-gray-100 border border-gray-200 rounded p-2 w-full md:w-1/2 focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                            onChange={(e) =>
                              setData({
                                ...data,
                                customerVatRegister: escapeHtml(e.target.value),
                              })
                            }
                            value={data.customerVatRegister}
                            type="number"
                            onWheel={(e) => e.target.blur()}
                            required
                          />
                          <Switch
                            className="ml-4"
                            onChange={() =>
                              setData({
                                ...data,
                                customerVatRegisterSwitch:
                                  !data.customerVatRegisterSwitch,
                              })
                            }
                            checked={data.customerVatRegisterSwitch}
                            color="success"
                          />
                        </div>
                      </div>

                      <div className="space-y-2">
                        <label className="block text-sm font-medium text-gray-700">
                          External Design Cost
                        </label>
                        <input
                          className="bg-gray-100 border border-gray-200 rounded p-2 w-full md:w-1/2 focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                          onChange={(e) =>
                            setData({
                              ...data,
                              externalDesingCost: escapeHtml(e.target.value),
                            })
                          }
                          value={data.externalDesingCost}
                          type="number"
                          onWheel={(e) => e.target.blur()}
                          required
                        />
                      </div>

                      <hr className="my-4" />

                      <div className="mt-8 p-4 bg-gray-50 border border-gray-200 rounded-lg">
                        <div className="space-y-2">
                          <label className="block text-sm font-medium text-gray-700">
                            Total cost
                          </label>
                          <div className="relative">
                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                              <span className="text-gray-700">£</span>
                            </div>
                            <input
                              className="bg-gray-100 border border-gray-200 rounded p-2 w-full pl-8 focus:outline-none focus:ring-2 focus:ring-lightgreen transition font-medium text-gray-800"
                              disabled
                              value={result}
                              type="number"
                              onWheel={(e) => e.target.blur()}
                              required
                            />
                          </div>
                        </div>
                      </div>

                      <div className="flex items-center space-x-4">
                        <label className="text-sm font-medium text-gray-700">
                          Adaptions are included in the quotation
                        </label>
                        <Switch color="success" />
                      </div>

                      <div className="pt-6 flex space-x-4">
                        <button
                          onClick={handleCalculate}
                          className="px-6 py-2 bg-lightgreen hover:bg-darkgreen text-white font-medium rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-lightgreen transition-colors"
                        >
                          Calculate
                        </button>
                        <button className="px-6 py-2 bg-lightgreen hover:bg-darkgreen text-white font-medium rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-lightgreen transition-colors">
                          Edit
                        </button>
                        <button
                          onClick={handleSubmit}
                          className="px-6 py-2 bg-lightgreen hover:bg-darkgreen text-white font-medium rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-lightgreen transition-colors"
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* Right Column - Job Information */}
                  <div className="w-full lg:w-1/2">
                    <div className="bg-white border border-gray-200 rounded-lg p-6 sticky top-20">
                      <h3 className="text-lg font-medium text-gray-800 mb-4">
                        Job Information
                      </h3>

                      <div className="space-y-6">
                        <div>
                          <h4 className="text-md font-bold text-gray-700">
                            Job Description
                          </h4>
                          <p className="text-sm text-gray-600 mt-1">
                            {stateSingleJob.jobDescription}
                          </p>
                        </div>

                        <div>
                          <h4 className="text-md font-bold text-gray-700">
                            Job Access
                          </h4>
                          <p className="text-sm text-gray-600 mt-1">
                            {stateSingleJob.jobDetails}
                          </p>
                        </div>
                      </div>

                      <div className="mt-6">
                        <img
                          src={outro}
                          alt="Site diagram"
                          className="w-full object-contain"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Mobile content section - Only visible when sidebar is closed on mobile */}
        {!isNonMobile && !sidebarOpen && (
          <div className="w-full pb-20">
            <div className="w-full flex justify-between mt-4 px-2">
              <div className="flex space-x-2">
                <p className="text-base text-slate-700 pb-1 font-medium whitespace-nowrap">
                  Temporary Roof Quote
                  <CircleIcon
                    sx={{ width: "14px", height: "14px" }}
                    className="text-green-600 ml-1"
                  />
                </p>
              </div>
            </div>
            {/* Mobile version of the form */}
            <div className="w-full px-2 mt-2">
              <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
                <div className="flex flex-col lg:flex-row gap-6">
                  {/* Left Column - Form */}
                  <div className="w-full lg:w-1/2">
                    <div className="space-y-6">
                      <div className="space-y-2">
                        <label className="block text-sm font-medium text-gray-700">
                          Select the date of erection
                        </label>
                        <input
                          className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                          value={data.dateOfErection}
                          type="date"
                          onChange={(e) =>
                            setData({
                              ...data,
                              dateOfErection: new Date(e.target.value).toISOString().split('T')[0],
                              nextInspectionDate: new Date(e.target.value).toISOString().split('T')[0],
                            })
                          }
                          required
                        />
                      </div>

                      <div className="space-y-2">
                        <label className="block text-sm font-medium text-gray-700">
                          Enter the number of weeks required
                        </label>
                        <input
                          className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                          value={data.numberOfWeeks}
                          onChange={(e) =>
                            setData({
                              ...data,
                              numberOfWeeks: escapeHtml(e.target.value),
                            })
                          }
                          type="number"
                          onWheel={(e) => e.target.blur()}
                          required
                        />
                      </div>

                      <div className="space-y-2">
                        <label className="block text-sm font-medium text-gray-700">
                          Enter the number of standard weeks hire before overhire
                          commence
                        </label>
                        <input
                          className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                          onChange={(e) =>
                            setData({
                              ...data,
                              standardNumberOfWeek: escapeHtml(e.target.value),
                            })
                          }
                          value={data.standardNumberOfWeek}
                          type="number"
                          required
                          onWheel={(e) => e.target.blur()}
                        />
                      </div>

                      <div className="mt-8">
                        <h3 className="text-md font-medium text-gray-800 mb-4">
                          Temporary roof dimensions
                        </h3>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                          <div className="space-y-2">
                            <label className="block text-sm font-medium text-gray-700">
                              Enter the perimeter of your building{" "}
                              <span className="text-gray-400">(Red line)</span>
                            </label>
                            <input
                              className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                              value={data.permiterOfBuilding}
                              onChange={(e) =>
                                setData({
                                  ...data,
                                  permiterOfBuilding: escapeHtml(e.target.value),
                                })
                              }
                              type="number"
                              onWheel={(e) => e.target.blur()}
                              required
                            />
                          </div>

                          <div className="space-y-2">
                            <label className="block text-sm font-medium text-gray-700">
                              Number of lifts{" "}
                              <span className="text-gray-400">(Blue line)</span>
                            </label>
                            <input
                              className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                              value={data.numberOfLiftsForPerimeter}
                              onChange={(e) =>
                                setData({
                                  ...data,
                                  numberOfLiftsForPerimeter: escapeHtml(
                                    e.target.value
                                  ),
                                })
                              }
                              type="number"
                              onWheel={(e) => e.target.blur()}
                              required
                            />
                          </div>
                        </div>

                        <div className="space-y-2">
                          <label className="block text-sm font-medium text-gray-700">
                            Enter the width of the building
                          </label>
                          <input
                            className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                            value={data.widthOfBuilding}
                            onChange={(e) =>
                              setData({
                                ...data,
                                widthOfBuilding: escapeHtml(e.target.value),
                              })
                            }
                            type="number"
                            onWheel={(e) => e.target.blur()}
                            required
                          />
                        </div>

                        <div className="space-y-2">
                          <label className="block text-sm font-medium text-gray-700">
                            Enter the length of the building
                          </label>
                          <input
                            className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                            type="number"
                            onWheel={(e) => e.target.blur()}
                            value={data.lengthOfBuilding}
                            onChange={(e) =>
                              setData({
                                ...data,
                                lengthOfBuilding: escapeHtml(e.target.value),
                              })
                            }
                            required
                          />
                        </div>

                        <div className="space-y-2">
                          <label className="block text-sm font-medium text-gray-700">
                            Enter the height from your guttering to the top of roof{" "}
                            <span className="text-gray-400">(Green line)</span>
                          </label>
                          <input
                            className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                            type="number"
                            onWheel={(e) => e.target.blur()}
                            value={data.HeightFromGutteringToTop}
                            onChange={(e) =>
                              setData({
                                ...data,
                                HeightFromGutteringToTop: escapeHtml(e.target.value),
                              })
                            }
                            required
                          />
                        </div>
                      </div>

                      <div className="space-y-2">
                        <label className="block text-sm font-medium text-gray-700">
                          Shrinkwrap or Monoflex
                        </label>
                        <select
                          className="bg-gray-100 border border-gray-200 rounded p-2 w-full md:w-2/3 focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                          onChange={(e) =>
                            setData({
                              ...data,
                              monoflexOrShrinkWrap: escapeHtml(e.target.value),
                            })
                          }
                        >
                          <option>Select</option>
                          <option
                            selected={
                              statePriceList.monoflex === data.monoflexOrShrinkWrap
                            }
                            value={statePriceList.monoflex}
                          >
                            Monoflex
                          </option>
                          <option
                            selected={
                              statePriceList.shrinkwrap === data.monoflexOrShrinkWrap
                            }
                            value={statePriceList.shrinkwrap}
                          >
                            Shrinkwrap
                          </option>
                        </select>
                      </div>

                      <div className="flex items-center space-x-4">
                        <label className="text-sm font-medium text-gray-700">
                          Weekly Scaffolding Inspections
                        </label>
                        <Switch
                          onChange={() =>
                            setData({
                              ...data,
                              weeklyScoffoldingInspectionSwitch:
                                !data.weeklyScoffoldingInspectionSwitch,
                            })
                          }
                          checked={data.weeklyScoffoldingInspectionSwitch}
                          color="success"
                        />
                      </div>

                      <div className="space-y-2">
                        <label className="block text-sm font-medium text-gray-700">
                          Enter the Street license Cost
                        </label>
                        <input
                          className="bg-gray-100 border border-gray-200 rounded p-2 w-full md:w-1/2 focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                          type="number"
                          onChange={(e) =>
                            setData({
                              ...data,
                              streetLicenseCost: escapeHtml(e.target.value),
                            })
                          }
                          value={data.streetLicenseCost}
                          onWheel={(e) => e.target.blur()}
                          required
                        />
                      </div>

                      <div className="space-y-2">
                        <label className="block text-sm font-medium text-gray-700">
                          Customer is VAT Registered
                        </label>
                        <div className="flex items-center">
                          <input
                            className="bg-gray-100 border border-gray-200 rounded p-2 w-full md:w-1/2 focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                            onChange={(e) =>
                              setData({
                                ...data,
                                customerVatRegister: escapeHtml(e.target.value),
                              })
                            }
                            value={data.customerVatRegister}
                            type="number"
                            onWheel={(e) => e.target.blur()}
                            required
                          />
                          <Switch
                            className="ml-4"
                            onChange={() =>
                              setData({
                                ...data,
                                customerVatRegisterSwitch:
                                  !data.customerVatRegisterSwitch,
                              })
                            }
                            checked={data.customerVatRegisterSwitch}
                            color="success"
                          />
                        </div>
                      </div>

                      <div className="space-y-2">
                        <label className="block text-sm font-medium text-gray-700">
                          External Design Cost
                        </label>
                        <input
                          className="bg-gray-100 border border-gray-200 rounded p-2 w-full md:w-1/2 focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                          onChange={(e) =>
                            setData({
                              ...data,
                              externalDesingCost: escapeHtml(e.target.value),
                            })
                          }
                          value={data.externalDesingCost}
                          type="number"
                          onWheel={(e) => e.target.blur()}
                          required
                        />
                      </div>

                      <hr className="my-4" />

                      <div className="mt-8 p-4 bg-gray-50 border border-gray-200 rounded-lg">
                        <div className="space-y-2">
                          <label className="block text-sm font-medium text-gray-700">
                            Total cost
                          </label>
                          <div className="relative">
                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                              <span className="text-gray-700">£</span>
                            </div>
                            <input
                              className="bg-gray-100 border border-gray-200 rounded p-2 w-full pl-8 focus:outline-none focus:ring-2 focus:ring-lightgreen transition font-medium text-gray-800"
                              disabled
                              value={result}
                              type="number"
                              onWheel={(e) => e.target.blur()}
                              required
                            />
                          </div>
                        </div>
                      </div>

                      <div className="flex items-center space-x-4">
                        <label className="text-sm font-medium text-gray-700">
                          Adaptions are included in the quotation
                        </label>
                        <Switch color="success" />
                      </div>

                      <div className="pt-6 flex space-x-4">
                        <button
                          onClick={handleCalculate}
                          className="px-6 py-2 bg-lightgreen hover:bg-darkgreen text-white font-medium rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-lightgreen transition-colors"
                        >
                          Calculate
                        </button>
                        <button className="px-6 py-2 bg-lightgreen hover:bg-darkgreen text-white font-medium rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-lightgreen transition-colors">
                          Edit
                        </button>
                        <button
                          onClick={handleSubmit}
                          className="px-6 py-2 bg-lightgreen hover:bg-darkgreen text-white font-medium rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-lightgreen transition-colors"
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default TemporaryRoofQuotes;
